import React from "react";
import Card from "../Card/Card.jsx";
import PaginationComponent from "../Pagination/PaginationComponent.jsx";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import SkeletonWrapper from "../SkeletonWrapper/SkeletonWrapper.jsx";
import useSkeleton from "../hooks/useSkeleton.jsx";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner.jsx";

const CostUnits = (props) => {
  const {
    costUnits,
    count,
    params,
    callBackUrlQuery,
    propertiesInfoText,
    svgObjects,
    state,
  } = props;

  const { translate } = tampuuriWindowObject();
  const { dummyCostUnitCards } = useSkeleton();

  const overrideCallBack = (params) => {
    // Call params change
    callBackUrlQuery(params);
    // Afterwards scroll to top
    const element = document.getElementById("results-container");
    const offset = 100; // pixels from top

    const elementTop = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementTop - offset,
      behavior: "smooth",
    });
  };

  return (
    <div className="results-container">
      <h2 id="search-results" className="type-h3 hoas-margin-top">
        {translate("Haettavia kohteita")}:{" "}
        {state?.loading ? <LoadingSpinner useSpinner="ClipLoader" /> : count}
      </h2>

      {propertiesInfoText && (
        <div className="col-10 info-text">
          <div dangerouslySetInnerHTML={{ __html: propertiesInfoText }} />
        </div>
      )}

      <div
        role="group"
        aria-labelledby="search-results"
        className="grid-container-gap"
      >
        <SkeletonWrapper
          loading={state?.loading}
          skeleton={dummyCostUnitCards()}
        >
          {costUnits?.map((card) => {
            return (
              <Card
                svgObjects={svgObjects}
                className="tampuuri-card--item card--item--property"
                key={card?.permalink}
                card={card}
              />
            );
          })}
        </SkeletonWrapper>
      </div>
      {!state?.loading && (
        <PaginationComponent
          params={params}
          count={count}
          callBackUrlQuery={overrideCallBack}
        />
      )}
    </div>
  );
};

export default CostUnits;
